import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import {
  isCreditScoreAbove650,
  isCreditScoreBelow650,
  isEnrolledNotFunded,
  isNotEnrolled,
} from 'helpers/sesameCash.helpers';
import { useEventHandler } from 'hook/event.hook';
import { useFlag } from 'hook/flag.hook';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useRoutingHelpers } from 'hook/routing.hook';
import {
  ACCUMULATE_CASH_PROMO,
  ACCUMULATE_CASH_PROMO_UNFUNDED,
} from 'types/morph.pagePosition.constants';
import AccumulateSegmentCashPromotionView from 'partial/OfferManager/modules/AccumulateSegmentCashPromotion/AccumulateSegmentCashPromotionView';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';
import { CashBalanceModule } from '../CashBalance/CashBalanceModule';
import { useEnrolledCashAccount } from 'hook/cashEnrolledHelper.hook';
import SesameCashCb20UpsellModuleController from '../SesameCashCb20Upsell';
import { isNonControlVariationLoadedAndEnabled } from 'helpers/optimizely.helper';

const buildTextConfig = (c, isOverview) => {
  const notEnrolledConfig =
    c?.cashFlag?.config?.module_accumulate_cash_promo_unenrolled_config;
  const enrolledNotFundedConfig =
    c?.cashFlag?.config?.module_accumulate_cash_promo_unfunded_config;
  const notEnrolledOverviewConfig =
    c?.cashFlag?.config
      ?.module_accumulate_cash_promo_unenrolled_overview_config;

  if (c?.forceNotFunded) {
    return enrolledNotFundedConfig;
  } else if (c?.isUserEnrolledNotFunded) {
    return enrolledNotFundedConfig;
  } else if (c?.isUserNotEnrolled && isOverview) {
    return notEnrolledOverviewConfig;
  } else return notEnrolledConfig;
};

const AccumulateSegmentCashPromotionController = props => {
  const cb20GaWebFlag = useFlag('cb2_0_ga_web');
  const isCb20GaWebFlag = isNonControlVariationLoadedAndEnabled(cb20GaWebFlag);
  const isUserEnrolledNotFunded = isEnrolledNotFunded(
    props.userInfo,
    props.sesameCashAccount,
  );
  const isUserNotEnrolled = isNotEnrolled(props.userInfo);
  const eventHandler = useEventHandler();
  const atr = getViewModuleTrackingAttributes({
    pagePosition: isUserEnrolledNotFunded
      ? ACCUMULATE_CASH_PROMO_UNFUNDED
      : ACCUMULATE_CASH_PROMO,
    modulePosition: props.modulePosition,
    vertical: BANKING_VERTICAL,
  });
  const seenPixel = useSeenModulePixel(atr);

  const routing = useRoutingHelpers();

  const cashFlag = useFlag('cash');
  const textConfig = buildTextConfig(
    {
      cashFlag,
      isUserEnrolledNotFunded,
      isUserNotEnrolled,
      forceNotFunded: props?.forceNotFunded,
    },
    props.isOverview,
  );

  const enrolledState = useEnrolledCashAccount({
    sesameCashAccount: props.sesameCashAccount,
    eventHandler: props.eventHandler,
    userInfo: props.userInfo,
  });

  const onCtaClickLearnMore = () => {
    eventHandler(CLICK, {
      'Click Type': 'Learn More',
    });
    routing.goToPath('/cash');
  };

  const onCtaClick = _ => {
    if (isUserNotEnrolled && props.isOverview) {
      eventHandler(CLICK, {
        'Click Type': 'Sesame Cash Overview',
        ...atr,
      });
      routing.goToPath('/cash');
    } else if (isUserEnrolledNotFunded) {
      eventHandler(CLICK, {
        'Click Type': 'Add Money',
        ...atr,
      });
      routing.goToModalPath('/cashAccount/transferOptions');
    } else {
      eventHandler(CLICK, {
        'Click Type': 'Enroll Accept',
        ...atr,
      });
      routing.goToPath('/sesameCashEnrollment/enroll');
    }
  };

  if (
    isCb20GaWebFlag &&
    props?.isOverview &&
    isNotEnrolled(props?.userInfo) &&
    isCreditScoreBelow650(props?.creditInfo)
  ) {
    return (
      <SesameCashCb20UpsellModuleController
        {...props}
        copyConfig={
          cb20GaWebFlag?.config?.module_unenrolled_user?.scoreBelow650Config
        }
        onCtaClick={onCtaClickLearnMore}
      />
    );
  } else if (
    isCb20GaWebFlag &&
    props?.isOverview &&
    isNotEnrolled(props?.userInfo) &&
    isCreditScoreAbove650(props?.creditInfo)
  ) {
    return (
      <SesameCashCb20UpsellModuleController
        {...props}
        copyConfig={
          cb20GaWebFlag?.config?.module_unenrolled_user?.scoreAbove650Config
        }
        imagePath={'/images/art-sesamecashdebitaccount.png'}
        onCtaClick={onCtaClickLearnMore}
      />
    );
  } else if (isEnrolledNotFunded(props.userInfo, props.sesameCashAccount)) {
    if (props.isCashPage) return <></>;
    return <CashBalanceModule {...enrolledState} {...props} />;
  } else {
    return (
      <AccumulateSegmentCashPromotionView
        {...textConfig}
        onCtaClick={onCtaClick}
        seenPixel={seenPixel}
      />
    );
  }
};

export default AccumulateSegmentCashPromotionController;
